// extracted by mini-css-extract-plugin
export default {"button":"cHvRkouGV_B87xHMFUUD","content":"U2kypP4CJPgFOFbRHYMU","qr":"mXLLCyDJXLVmjeGZA2hl"};